import { Component, Prop, State, h } from '@stencil/core';
import gearbox from 'qumra-gearbox';

@Component({
  tag: 'qumra-quantity-input',
  styleUrl: 'qumra-quantity-input.css',
  shadow: false,
  formAssociated: true,
})
export class QumraQuantityInput {
  @Prop() value: number | string | undefined;
  @Prop() max: number | string | undefined;
  @Prop() min: number | string | undefined = 1;
  @Prop() stock: number | string | undefined;
  @Prop() size: string = "32px";
  @Prop() callback: string;
  @Prop() item: string;

  @State() currentValue: number;

  private toNumber(val: number | string | undefined, defaultVal: number): number {
    if (val === undefined || val === null || isNaN(Number(val))) {
      return defaultVal;
    }
    return Number(val);
  }

  componentWillLoad() {
    const valueVal = this.toNumber(this.value, NaN); 

    if (!isNaN(valueVal)) {
      this.currentValue = valueVal;
    } else {
      this.currentValue = this.toNumber(this.min, 1); 
    }

    const maxVal = this.toNumber(this.max, this.toNumber(this.stock, Infinity)); 
    this.currentValue = Math.min(this.currentValue, maxVal); 
  }

  increase() {
    const newVal = this.currentValue + 1;
    const maxVal = this.toNumber(this.max, this.toNumber(this.stock, Infinity));  

    if (newVal > maxVal) {
      gearbox.notify.info('لقد وصلت الحد الأقصى');
      return;
    }

    this.currentValue = newVal;
    this.updateCartQuantity(newVal);
  }

  decrease() {
    const newVal = this.currentValue - 1;
    const minVal = this.toNumber(this.min, 1);

    if (newVal < minVal) {
      gearbox.notify.info('لقد وصلت الحد الأدنى');
      return;
    }

    this.currentValue = newVal;
    this.updateCartQuantity(newVal);
  }

  updateCartQuantity(quantity: number) {
    if (window?.Qumra?.cart?.updateQuantity) {
      window.Qumra.cart.updateQuantity(this.item, quantity);
    }
  }

  render() {
    return (
      <div class="qumra-quantity-container">
        <button
          aria-label="increase"
          style={{ width: this.size, height: this.size }}
          type="button"
          onClick={() => this.increase()}
          class="qumra-quantity-input-button qumra-lg:w-10 qumra-lg:h-10 qumra-w-6 qumra-h-6"
        >
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.0248 3.32505C8.0248 3.0351 7.78975 2.80005 7.4998 2.80005C7.20986 2.80005 6.9748 3.0351 6.9748 3.32505V6.47505H3.8248C3.53486 6.47505 3.2998 6.7101 3.2998 7.00005C3.2998 7.29 3.53486 7.52505 3.8248 7.52505L6.9748 7.52505V10.675C6.9748 10.965 7.20986 11.2 7.4998 11.2C7.78975 11.2 8.0248 10.965 8.0248 10.675V7.52505H11.1748C11.4648 7.52505 11.6998 7.29 11.6998 7.00005C11.6998 6.7101 11.4648 6.47505 11.1748 6.47505H8.0248V3.32505Z"
              fill="#333333"
              stroke="#333333"
              stroke-width="0.5"
              stroke-linecap="round"
            />
          </svg>
        </button>

        <input
          style={{ width: this.size, height: this.size }}
          type="text"
          value={this.currentValue}
          name="quantity"
          readonly
          class="qumra-quantity-input qumra-lg:w-10 qumra-lg:h-10 qumra-w-6 qumra-h-6"
        />

        <button
          aria-label="decrease"
          style={{ width: this.size, height: this.size }}
          type="button"
          onClick={() => this.decrease()}
          class="qumra-quantity-input-button qumra-lg:w-10 qumra-lg:h-10 qumra-w-6 qumra-h-6"
        >
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.2998 7.0001C3.2998 6.71015 3.53486 6.4751 3.8248 6.4751L11.1748 6.4751C11.4648 6.4751 11.6998 6.71015 11.6998 7.0001C11.6998 7.29005 11.4648 7.5251 11.1748 7.5251L3.8248 7.5251C3.53486 7.5251 3.2998 7.29005 3.2998 7.0001Z"
              fill="#333333"
              stroke="#333333"
              stroke-width="0.5"
              stroke-linecap="round"
            />
          </svg>
        </button>
      </div>
    );
  }
}
